module.exports = __webpack_public_path__ + "static/tt_legal-295ef5bd048a8798929274a6da21a878.pdf";